import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirect for legacy dynamic URLs: forwards the matched `:id` into the current
 * path builder (e.g. `/fundraisings/:id/edit` → `paths.fundraisings.dialog(id)`).
 * Lives outside the route fragments so they keep exporting only route elements
 * (react-refresh constraint).
 */
export default function ParamRedirect({ to }: { to: (id: string) => string }) {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={to(id ?? '')} replace />;
}
